import React, { Component } from 'react'
import './Result.css'

class Result extends Component {
  render() {
    return (
      <div>
        <h1 className="result">
          Most likely root causes went through analysis Successfully
        </h1>
        <h2 className="result">we will inform you soon ...</h2>
      </div>
    )
  }
}

export default Result
